import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import './ReactQuillEditor.css';
import ImageResize from 'quill-image-resize-module-react';
import Quill from 'quill';

// ลงทะเบียน module สำหรับย่อ-ขยายรูปภาพ
Quill.register('modules/imageResize', ImageResize);

const modules = {
  toolbar: {
    container: [
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
    handlers: {
      image: function () {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
          const file = input.files[0];
          const formData = new FormData();
          formData.append('image', file);

          try {
            const res = await axios.post(`${API_BASE_URL}/api/uploads/news-image`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });

            const range = this.quill.getSelection();
            this.quill.insertEmbed(range.index, 'image', `${API_BASE_URL}${res.data.url}`);
          } catch (err) {
            console.error('Upload failed', err);
          }
        };
      },
    },
  },
  // ✅ module ระดับเดียวกับ toolbar — เปิดให้คลิกเลือกรูปแล้วลากมุมย่อ-ขยายได้
  imageResize: {
    modules: ['Resize', 'DisplaySize'],
    showSize: true,
  },
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'align',
  'list', 'bullet',
  'link', 'image'
];

const RichTextEditor = ({ value, onChange }) => {
  const quillRef = useRef();

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      modules={modules}
      formats={formats}
      value={value}
      onChange={onChange}
      style={{ height: '400px' }}
    />
  );
};

export default RichTextEditor;
